<template>
  <div class="informationTemplate-bd bd">
    <div class="aside">
      <div class="title">
        <i class="icon icon-langset"></i>
        <span>{{ $t('base_messagetpl.xiao_xi_mu_ban') }}</span>
      </div>
      <div class="search">
        <custom-select
          v-model="form.langCode"
          code="language_type"
          :clearable="false"
          :props="{ label: 'name', value: 'value' }"
          width="100%"
          :placeholder="$t('Common.com_please_select')"
          style="margin-bottom: 14px; vertical-align: top"
          @change="getMsgTemplate"
        ></custom-select>
        <div class="ub">
          <div class="ub-f1">
            <el-input style="vertical-align: top; width: 100%" :placeholder="$t('base_messagetpl.mu_ban_ming_cheng')" v-model="appKey" @input="filterTree"></el-input>
          </div>
          <div style="margin-left: 10px">
            <add-button v-if="funcView.msg_template_addGroup" @click="addTemplateGroup(null)"></add-button>
          </div>
        </div>
      </div>
      <div class="tree" v-if="funcView.msg_template_list">
        <el-tree
          ref="tree"
          :data="templateList"
          :props="treeProps"
          node-key="id"
          :highlight-current="true"
          :expand-on-click-node="true"
          :default-expand-all="true"
          @node-click="handleNodeClick"
          :default-expanded-keys="expandedKeys"
          :filter-node-method="filterNode"
        >
          <span v-if="data.id === tempalteData.id" class="tree-item" slot-scope="{ data }">
            <span class="line1">{{ data.name }}</span>
            <span>
              <el-button type="text" @click.stop="addTemplateGroup(data)" v-if="data.data.groupLevel != 2 && funcView.msg_template_addGroup" size="mini">
                <i class="icon icon-add"></i>
              </el-button>
              <el-button type="text" @click.stop="editTemplateGroup(data)" v-if="funcView.msg_template_editGroup" size="mini">
                <i class="icon icon-bianji"></i>
              </el-button>
              <el-button type="text" @click.stop="deleteTemplateGroup(data)" v-if="funcView.msg_template_deleteGroup" size="mini">
                <i class="icon icon-shanchu"></i>
              </el-button>
            </span>
          </span>
          <span class="tree-item" v-else>
            <span class="line1">{{ data.name }}</span>
          </span>
        </el-tree>
      </div>
    </div>

    <div class="section" v-if="tempalteData.data && `${tempalteData.data.groupLevel}` === '2'">
      <div class="wrap ubv">
        <el-collapse v-model="form.templType" @change="onAppItem" accordion>
          <el-collapse-item v-for="(item, index) in propertyMap.bas_msg_send_channel" :key="index" :name="item.value">
            <template slot="title">
              <!-- <i v-if="index === 0" class="icon icon-app"></i>
              <i v-if="index === 1" class="icon icon-youjianduanxin"></i>
              <i v-if="index === 2" class="icon icon-diannao"></i>
              <i v-if="index === 3" class="icon icon-youjian"></i> -->
              <i class="icon icon-youjian" style="font-size: 18px"></i>
              {{ item.name }}
            </template>
            <div class="box">
              <el-form :inline="true" :model="form" ref="form">
                <el-row v-if="tempalteData">
                  <el-form-item style="width: 100%; margin-bottom: 40px" :label="$t('base_messagetpl.can_shu_dai_xuan_qu')">
                    <el-tag style="cursor: pointer; margin-right: 10px" v-for="(item, index) in tempalteData.dicList" :key="index" @click="setFocusContent(item.value)">{{ item.name }}</el-tag>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item style="width: 100%; margin-bottom: 10px" :label="$t('base_messagetpl.biao_ti')" class="form-must">
                    <el-input placeholder="" v-model="form.title" :disabled="tempalteData && !tempalteData.id" style="width: 100%" @blur="onFocus" @focus="focusKey = 'title'"></el-input>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item style="width: 100%; margin-bottom: 10px" :label="$t('base_messagetpl.fu_biao_ti')">
                    <el-input placeholder="" v-model="form.subTitle" :disabled="tempalteData && !tempalteData.id" style="width: 100%" @blur="onFocus" @focus="focusKey = 'subTitle'"></el-input>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item style="width: 100%; margin-bottom: 20px" :label="$t('base_messagetpl.nei_rong')" class="form-must">
                    <custom-editor
                      v-if="item.code === 'email'"
                      :menubar="false"
                      :ref="'editor' + index"
                      :key="index"
                      v-model="form.contentEditor"
                      :height="240"
                      @focus="focusKey = 'contentEditor'"
                      @blur="onFocus"
                      folder="isc/richtext/notice"
                    ></custom-editor>
                    <el-input type="textarea" rows="10" v-else v-model="form.content" :disabled="tempalteData && !tempalteData.id" style="width: 100%" @blur="onFocus" @focus="focusKey = 'content'"></el-input>
                  </el-form-item>
                </el-row>
                <el-row style="overflow: hidden">
                  <el-form-item class="mb-0">
                    <el-button type="primary" @click="saveMsgTemplate" v-if="funcView.msg_template_save" :disabled="!isSubmit">{{ $t('Common.com_save') }}</el-button>
                    <el-button @click="resetMsgTemplate" v-if="funcView.msg_template_reset" :disabled="!isSubmit">{{ $t('Common.com_reset') }}</el-button>
                  </el-form-item>
                </el-row>
              </el-form>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <!-- 分组弹窗 -->
    <template-tree-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="successCallBack"></template-tree-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import addButton from '@/components/addButton';
import customEditor from '@/components/customEditor/index.vue';
import templateTreeDialog from './children/template_tree_dialog';

export default {
  name: 'messagetpl',
  components: { templateTreeDialog, addButton, customEditor },
  data() {
    return {
      // translate: { i18n, funcView },
      // provide: true,
      focusKey: '',
      focusIdx: -1,
      content: '',
      treeProps: {
        children: 'children',
        label: 'name',
      },
      tabs: [],
      expandedKeys: ['1'],
      templateList: [],
      tempalteData: {},
      appKey: '',
      dialogVisible: false,
      dialogModel: {},
      form: {
        langCode: 'CN',
        title: '',
        subTitle: '',
        content: '',
        contentEditor: '',
        // 模板类型
        templType: 'app',
      },
    };
  },
  computed: {
    rules() {
      return {
        title: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), },
        ],
        content: {
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
    isSubmit: vm => vm.form.title && (vm.form.content || vm.form.contentEditor),
  },
  mounted() {
    this.getTemplateTree();
    this.getDictionary('bas_msg_send_channel,bas_msg_biz_type');
    this.getFuncView();

  },
  methods: {
    // 光标下标
    onFocus(e) {
      this.focusIdx = e.target.selectionStart;
    },
    // 设置内容
    setFocusContent(str) {
      if (this.focusKey) {
        const val = this.form[this.focusKey];
        if (this.focusIdx === -1) {
          this.form[this.focusKey] = `${this.form[this.focusKey]}${str}`;
        } else {
          this.form[this.focusKey] = `${val.slice(0, this.focusIdx)}${str}${val.slice(this.focusIdx)}`;
          this.focusIdx = -1;
        }
        this.updateForm();
      }
    },
    // 获取消息推送模板树
    getTemplateTree: function (type) {
      this.$getJSON(apis.MsgTemplateGroupTree).then((res) => {
        this.templateList = res.data;
        this.$nextTick(() => {
          if (type === 'delete') {
            // 清空模板消息
            this.tempalteData.id = null;
            this.tempalteData.data = null;
          }
          if (this.tempalteData.id) {
            this.$refs.tree.setCurrentKey(this.tempalteData.id);
            if (this.tempalteData.data.groupLevel === '2') {
              // 获取当前选中的树节点判断要不要去获取右侧
              this.getMsgTemplate();
            }
          }
        });
      });
    },
    // editor的value被再次修改后， view中数据不同步 需要手动更新
    updateForm() {
      const value = this.form.templType;
      const index = this.propertyMap.bas_msg_send_channel.findIndex(item => item.value === value);
      const inst = Array.isArray(this.$refs[`editor${index}`]) ? this.$refs[`editor${index}`][0] : this.$refs[`editor${index}`];
      if (inst) {
        this.$nextTick(() => {
          inst.update();
        });
      }
    },
    // 获取模板内容
    getMsgTemplate: function () {
      this.form.title = '';
      this.form.subTitle = '';
      this.form.content = '';
      this.form.contentEditor = '';
      // 只有平台  邮件 才是富文本  isRichText是1
      if (this.form.templType === 'email') {
        this.form.isRichText = 1;
      } else {
        this.form.isRichText = 0;
      }
      this.$getJSON(`${apis.MsgTemplateGet}/?templGroupId=${this.tempalteData.id}&templType=${this.form.templType}&langCode=${this.form.langCode}`).then((res) => {
        setTimeout(() => {
          this.form.title = res.data ? res.data.title : '';
          this.form.subTitle = res.data ? res.data.subTitle : '';
          this.form.content = res.data ? res.data.content : '';
          this.form.contentEditor = res.data ? res.data.content : '';
          this.updateForm();
        }, 200);
      });
    },
    // 选中树
    handleNodeClick: function (row) {
      if (!this.funcView.msg_template_checkGroup) {
        return;
      }
      this.expandedKeys = [row.id];
      // 当前选中的分组
      this.tempalteData = row;
      this.focusKey = '';
      const dic = this.propertyMap.bas_msg_biz_type.find(item => item.value === row.data.msgBizCode);
      this.tempalteData.dicList = dic ? dic.children : [];
      // 叶子才会获取模板内容
      // 更新右边数据
      this.getMsgTemplate();
    },
    // 添加 编辑分组成功的回调
    successCallBack() {
      // 树更新
      this.getTemplateTree();
    },
    // 搜索过滤事件
    filterTree: function () {
      this.$refs.tree.filter(this.appKey);
    },
    // 搜索过滤
    filterNode: function (value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    // 新增岗位
    addTemplateGroup: function (data) {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('base_messagetpl.xzxxmb');
      this.dialogModel.data = data;
      this.dialogVisible = true;
    },
    // 编辑岗位
    editTemplateGroup: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('base_messagetpl.bjxxmb');
      this.dialogModel.data = data.data; // 当前模板信息
      this.dialogVisible = true;
    },
    // 删除岗位
    deleteTemplateGroup: function ({ data }) {
      const tips = this.$t('base_messagetpl.nqdyscxzdxxmbm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.MsgTemplateGroupDelete}/${data.templGroupId}`).then(() => {
            this.expandedKeys = [data.parentId];
            // 更新右侧数据 delete清空选中 与模板内容
            this.getTemplateTree('delete');
          });
        })
        .catch(() => {});
    },
    // 发送类型类型切换
    onAppItem: function (value) {
      // console.log('value', value);
      // if (value) {
      //   // propertyMap.bas_msg_push_template_type
      //   const index = this.propertyMap.bas_msg_push_template_type.findIndex(item => item.value === value);
      //   // this.$refs[`editor${index}`].clearRecord();
      //   const inst = Array.isArray(this.$refs[`editor${index}`]) ? this.$refs[`editor${index}`][0] : this.$refs[`editor${index}`];
      //   setTimeout(() => {
      //     inst.clearRecord();
      //   }, 100);
      //   // console.log(this.$refs[`editor${index}`]);
      //   // console.log(this);
      // }
      // 类型切换 样式切换
      this.form.templType = value;
      // 拿数据 接口拿数据再清空
      this.getMsgTemplate();
    },
    // 保存模板内容
    saveMsgTemplate: function () {
      if (this.form.templType === 'email') {
        this.form.content = this.form.contentEditor;
      }
      const templGroupId = this.tempalteData.data.templGroupId;
      const parameter = { ...this.form, templGroupId };
      this.$postJSON(apis.MsgTemplateSave, parameter, true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
      });
    },
    // 重置模板内容
    resetMsgTemplate: function () {
      this.form.title = '';
      this.form.subTitle = '';
      this.form.content = '';
      this.form.contentEditor = '';
    },
  },
};
</script>

<style lang="scss">
@import '@/style/mixin.scss';

.informationTemplate-bd {
  background-color: rgba(228, 235, 242, 1) !important;
  .section {
    background: rgba(228, 235, 242, 1);
    padding: 0 !important;
    .el-tabs .el-tabs__item {
      font-size: 14px;
      color: #262626;
      font-weight: normal;
      line-height: 44px;
      height: 44px;
      &.is-active {
        font-weight: bold;
      }
    }
    .wrap {
      height: 100%;
      // padding: 16px 0;
      overflow-y: auto;
      background-color: rgba(228, 235, 242, 1);
      .el-collapse {
        border: none;
      }
      .el-collapse-item {
        margin-bottom: 16px;
      }
      .el-collapse-item__content {
        padding-bottom: 0;
      }
      .el-collapse-item.is-active {
        background: rgba(242, 243, 251, 1);
      }
      .el-collapse-item__header {
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        border: none;
        padding-left: 16px;
        padding-right: 6px;
        color: #495057;
        font-size: 12px;
        font-weight: bold;
        .icon {
          font-size: 14px;
          margin-right: 6px;
          @include color_main();
        }
      }
      .el-collapse-item__wrap {
        border-bottom: none;
        overflow: hidden;
      }
      .el-form-item__content {
        width: 100%;
      }
      .el-input .el-input__inner,
      .el-textarea__inner {
        // border: none !important;
        border: 1px solid rgba(222, 226, 230, 1);
        padding: 5px 10px;
      }
      .box {
        background: #fff;
        padding: 0 16px 16px;
      }

      .per-wrap {
        flex: 1;
        height: 0;
        padding: 16px;
        line-height: 20px;
        .title {
          color: $title-color;
          font-size: 15px;
          font-weight: bold;
        }
        .el-checkbox__label {
          color: #262626;
          line-height: 23px;
          font-weight: normal;
          font-size: 12px;
        }
        textarea {
          height: 100%;
        }
        .checkall {
          display: flex;
          align-items: center;
          padding-right: 15px;
          margin-right: 15px;
          position: relative;
          &::before {
            content: '';
            position: absolute;
            right: 0;
            top: 2px;
            bottom: 2px;
            width: 1px;
            background-color: #e4e4e4;
          }
        }
      }
    }
  }

  .mb-0 {
    margin-bottom: 0 !important;
  }

  .mce-tinymce {
    display: block !important;
  }
}
</style>
